import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { createWhatsAppUrl } from '../utils/whatsapp';
import './FloatingWhatsApp.css';

const { FiMessageCircle } = FiIcons;

function FloatingWhatsApp() {
  const openWhatsApp = () => {
    window.open(
      createWhatsAppUrl('Hi! I need help with the salon website.'),
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <motion.div
      className="whatsapp-float"
      animate={{ y: [0, -5, 0] }}
      transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }}
    >
      <span className="whatsapp-help-label">Need Help?</span>
      <button
        className="whatsapp-float-button"
        type="button"
        aria-label="Get help on WhatsApp"
        onClick={openWhatsApp}
      >
        <span className="whatsapp-pulse" />
        <SafeIcon icon={FiMessageCircle} />
      </button>
    </motion.div>
  );
}

export default FloatingWhatsApp;
